import { SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Drawer, Input, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { categories } from '../../../constants';
import { setCategory } from '../../../redux/slices/filtersSlice';
import { store } from '../../../redux/store';

const Categories = ({ open, onClose, onApply, value, onChange }) => {
    const { category: reduxCategory } = useSelector((state) => state.filtersSlice);
    const isControlled = value !== undefined && onChange !== undefined;
    const externalCategories = isControlled ? value : reduxCategory;

    const [searchCategory, setSearchCategory] = useState('');
    const [selectedCategories, setSelectedCategories] = useState([]);

    useEffect(() => {
        if (open) {
            setSelectedCategories(externalCategories || []);
        }
    }, [open, externalCategories]);

    const filteredCategories = useMemo(() => {
        const search = searchCategory.toLowerCase().trim();
        return search ? categories.filter((c) => c.toLowerCase().includes(search)) : categories;
    }, [searchCategory]);

    const handleChange = (newValue) => {
        setSelectedCategories((prev) => {
            const hiddenSelectedCategories = (prev || []).filter((cat) => !filteredCategories.includes(cat));
            return [...hiddenSelectedCategories, ...newValue];
        });
    };

    const handleApply = () => {
        if (isControlled) {
            onChange(selectedCategories);
        } else {
            let updated = [...reduxCategory];
            updated = updated.filter((f) => !categories.includes(f)).concat(selectedCategories);
            store.dispatch(setCategory(updated));
        }
        onApply?.(selectedCategories);
        onClose();
    };

    const handleClose = () => {
        setSelectedCategories(externalCategories || []);
        onClose();
    };

    return (
        <Drawer
            title="Categories"
            open={open}
            onClose={handleClose}
            footer={
                <Button block type="primary" onClick={handleApply}>
                    Apply
                </Button>
            }
        >
            <Input
                size="large"
                placeholder="Search categories"
                prefix={<SearchOutlined />}
                value={searchCategory}
                onChange={(e) => setSearchCategory(e.target.value)}
                allowClear
                className="mb-2"
            />
            <Checkbox.Group
                value={selectedCategories?.filter((f) => categories.includes(f))}
                onChange={(value) => handleChange(value)}
            >
                <Space direction="vertical">
                    {filteredCategories?.map((category) => (
                        <Checkbox key={category} value={category}>
                            {category}
                        </Checkbox>
                    ))}
                </Space>
            </Checkbox.Group>
        </Drawer>
    );
};

export default Categories;
